export default __webpack_public_path__ + "static/media/img-card-03.cea23d7d.jpg";